module.exports = __webpack_public_path__ + "img/city.ce76005c.svg";